import { render } from "./DockIcon.vue?vue&type=template&id=13fa22e1"
import script from "./DockIcon.vue?vue&type=script&lang=js"
export * from "./DockIcon.vue?vue&type=script&lang=js"

import "./DockIcon.vue?vue&type=style&index=0&id=13fa22e1&lang=scss"
script.render = render

export default script